import { useMemo, useState } from "react";

export type SearchConfig<T> = {
  searchableFields: Array<keyof T>;
  initialData: T[];
};

export type UseLocalSearchResult<T> = {
  value: string;
  onChange: (value: string) => void;
  filteredData: T[];
};

export const useLocalSearch = <T extends Record<string, any>>({
  searchableFields,
  initialData,
}: SearchConfig<T>): UseLocalSearchResult<T> => {
  const [searchValue, setSearchValue] = useState("");

  const filteredData = useMemo(() => {
    if (!searchValue) {
      return initialData;
    }

    const normalizedSearchTerm = searchValue.toLowerCase().trim();

    return initialData.filter((item) =>
      searchableFields.some((field) => {
        const fieldValue = String(item[field] || "");
        return fieldValue.toLowerCase().includes(normalizedSearchTerm);
      }),
    );
  }, [searchValue, initialData, searchableFields]);

  return {
    value: searchValue,
    onChange: setSearchValue,
    filteredData,
  };
};
